/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CaptchaChallenge } from '../models/CaptchaChallenge';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CaptchaService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns CaptchaChallenge
     * @throws ApiError
     */
    public captchaControllerCaptchaChallenge(): CancelablePromise<CaptchaChallenge> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/captcha/challenge',
        });
    }
}
